/**
 * Contract validators - Contract and agreement related types
 */
import { Infer, v } from 'convex/values';

// ============================================================================
// Contract Type
// ============================================================================

export const contractTypeValidator = v.union(
  v.literal('system_generated'),
  v.literal('substitute_custom')
);

export type ContractType = Infer<typeof contractTypeValidator>;

export const CONTRACT_TYPES = ['system_generated', 'substitute_custom'] as const;

// ============================================================================
// Contract Status
// ============================================================================

export const contractStatusValidator = v.union(
  v.literal('pending_substitute_upload'),
  v.literal('pending_provider_acceptance'),
  v.literal('changes_requested'),
  v.literal('pending_cancellation'),
  v.literal('accepted'),
  v.literal('rejected'),
  v.literal('expired'),
  v.literal('superseded')
);

export type ContractStatus = Infer<typeof contractStatusValidator>;

export const CONTRACT_STATUSES = [
  'pending_substitute_upload',
  'pending_provider_acceptance',
  'changes_requested',
  'pending_cancellation',
  'accepted',
  'rejected',
  'expired',
  'superseded',
] as const;
